import { combineReducers } from 'redux';
import exercise from './exercise';
import feedback from './feedback';
import loader from './loader';

const rootReducer = combineReducers({
	exercise,
	feedback,
	loader
});

export default rootReducer;

